import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const InitCurrentProductByQuery = props => {
  const { setCurrentProduct } = props;
  const searchParams = useSearchParams();

  useEffect(() => {
    const isInStock = searchParams.get('in-stock') === 'true';

    if (isInStock) {
      setCurrentProduct('available_product');
    }
  }, [searchParams, setCurrentProduct]);

  return null;
};

export default InitCurrentProductByQuery;
